import './side-bar-student-item.css';
import React, { useMemo } from 'react';
import AcademicIcon from '../../../assets/icons/side-bar-user/books-side-bar-icon.svg';
import ProfileIcon from '../../../assets/icons/side-bar-user/user-academic-side-bar-icon.svg';
import ServiceIcon from '../../../assets/icons/side-bar-user/services-side-bar-icon.svg';
import DocIcon from '../../../assets/icons/side-bar-user/side-bar-docs.svg';
import CalendarIcon from '../../../assets/icons/calendar-icon.svg';
import { Skeleton } from 'primereact/skeleton';
import globalUserPage from '../../../stores/global-user-page';
import { observer } from 'mobx-react-lite';

export enum StudentSideBarItemType {
  PROFILE,
  COURSES,
  LECTURES,
  LECTURES_CALENDAR,
  ACADEMIC,
  PAYMENT_SERVICES,
  DOCS,
  PERMISSIONS,
  WORKING_HOURS,
  SALARIES,
  EXAMS,
  ASSIGNMENTS,
  RATES,
  COURSE_FEEDBACKS,
  EXTERNAL_EXAMS,
  INSTALLMENTS_CREDIT_CARD,
  INSTALLMENTS_BANK_TRANSFER,
  PAYMENT_ITEMS,
  SCHOLARSHIPS,
}

interface StudentSideBarItem {
  type: StudentSideBarItemType;
  text: string;
  onClick: (itemType: StudentSideBarItemType) => void;
  isSelected?: boolean;
}

export const SideBarStudentItem: React.FC<StudentSideBarItem> = observer(
  ({ type, text, onClick, isSelected = false }) => {
    const isLoading = useMemo(
      () => globalUserPage.loading,
      [globalUserPage.loading],
    );
    const getIconByType = (type: StudentSideBarItemType) => {
      switch (type) {
        case StudentSideBarItemType.PAYMENT_SERVICES:
          return ServiceIcon;
        case StudentSideBarItemType.DOCS:
          return DocIcon;
        case StudentSideBarItemType.ACADEMIC:
          return AcademicIcon;
        case StudentSideBarItemType.PROFILE:
          return ProfileIcon;

        case StudentSideBarItemType.PERMISSIONS:
          return ProfileIcon;

        case StudentSideBarItemType.WORKING_HOURS:
          return CalendarIcon;

        case StudentSideBarItemType.COURSES:
          return ProfileIcon;

        case StudentSideBarItemType.SALARIES:
          return AcademicIcon;

        case StudentSideBarItemType.LECTURES:
          return DocIcon;
        case StudentSideBarItemType.LECTURES_CALENDAR:
          return CalendarIcon;

        case StudentSideBarItemType.EXAMS:
          return AcademicIcon;

        case StudentSideBarItemType.ASSIGNMENTS:
          return ServiceIcon;

        case StudentSideBarItemType.COURSE_FEEDBACKS:
          return DocIcon;

        case StudentSideBarItemType.EXTERNAL_EXAMS:
          return AcademicIcon;

        case StudentSideBarItemType.INSTALLMENTS_CREDIT_CARD:
          return CalendarIcon;

        case StudentSideBarItemType.INSTALLMENTS_BANK_TRANSFER:
          return ServiceIcon;

        case StudentSideBarItemType.SCHOLARSHIPS:
          return AcademicIcon;
      }
    };
    const getViewElement = () => {
      return (
        <div
          onClick={() => {
            onClick(type);
          }}
          className={`side-bar-item-container ${
            isSelected ? 'side-bar-item-container-selected' : ''
          }`}
        >
          <img src={getIconByType(type)} width={25} />
          <div
            style={{
              color: isSelected ? '#1d4ed8' : '#4b5563',
              marginRight: '8px',
              fontSize: '16px',
              fontWeight: isSelected ? 600 : 400,
            }}
          >
            {text}
          </div>
        </div>
      );
    };

    const getLoadingElement = () => {
      return (
        <div className={'side-bar-item-container'}>
          <Skeleton
            shape="circle"
            height={'20px'}
            width={'20px'}
            className="mr-2"
          />
          <div style={{ width: '8px' }} />
          <Skeleton
            width="10rem"
            className="mb-2"
            borderRadius="16px"
          ></Skeleton>
        </div>
      );
    };

    return (
      <div style={{ direction: 'rtl' }}>
        {isLoading ? getLoadingElement() : getViewElement()}
      </div>
    );
  },
);
